module.exports = __webpack_public_path__ + "assets/images/previews/1b.jpg";